var exports = {
  "lI": "DateOfBirthField.module__fieldset___S1Z1UW",
  "_A": "DateOfBirthField.module__labelContainer___S1Z1UW",
  "o1": "DateOfBirthField.module__legend___S1Z1UW",
  "$K": "DateOfBirthField.module__inputsContainer___S1Z1UW",
  "EN": "DateOfBirthField.module__fieldsRow___S1Z1UW",
  "tZ": "DateOfBirthField.module__monthField___S1Z1UW",
  "bc": "DateOfBirthField.module__dayField___S1Z1UW",
  "Y9": "DateOfBirthField.module__yearField___S1Z1UW",
  "kc": "DateOfBirthField.module__errorText___S1Z1UW",
  "Kd": "DateOfBirthField.module__nativeDateInput___S1Z1UW",
};

module.exports = exports;
